import { commonjsGlobal as u } from "./index61.js";
import { __exports as l } from "./index180.js";
import { c as i } from "./index194.js";
var a = u && u.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(l, "__esModule", { value: !0 });
l.default = _;
const p = a(i);
function _(t, n) {
  let e = null;
  if (!t || typeof t != "string")
    return e;
  const s = (0, p.default)(t), c = typeof n == "function";
  return s.forEach((r) => {
    if (r.type !== "declaration")
      return;
    const { property: f, value: o } = r;
    c ? n(f, o, r) : o && (e = e || {}, e[f] = o);
  }), e;
}
